export enum ReturnVerificationItemResult {
  Pending = "pending",
  ItemLikeNew = "item_like_new",
  ItemDamaged = "item_damaged",
  ItemNotReceived = "item_not_received",
}
